import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';
import InviteDownloadLinks from '../components/InviteDownloadLinks';
import './invite-landing.css';

const API = getApiBaseUrl();

export default function InviteLandingPage() {
    const { token } = useParams();
    const [subtitle, setSubtitle] = useState('Загрузка...');
    const [error, setError] = useState('');
    const [showLogin, setShowLogin] = useState(false);
    const [showOk, setShowOk] = useState(false);

    useEffect(() => {
        if (!token) {
            setSubtitle('Ссылка приглашения недействительна.');
            setError('Токен не найден.');
            return;
        }

        axios.get(`${API}/invite/${encodeURIComponent(token)}`)
            .then((res) => {
                if (!res.data?.valid) throw new Error(res.data?.error || 'invite_not_found');
                const role = res.data.expectedRole || 'участника';
                setSubtitle(`Вас приглашают в «${res.data.schoolName || 'школу'}» как ${role}.`);
                if (res.data.scenario === 'new_user' && res.data.activationUrl) {
                    window.location.href = res.data.activationUrl;
                    return;
                }
                setShowLogin(true);
                setShowOk(true);
            })
            .catch((err) => {
                setSubtitle('Приглашение недействительно или истекло.');
                setError(err.response?.data?.error || err.message || 'invite_not_found');
            });
    }, [token]);

    return (
        <div className="invite-landing-page">
            <div className="invite-landing-card">
                <h1>Приглашение в школу</h1>
                <p className="invite-landing-sub">{subtitle}</p>
                {showLogin && (
                    <a className="invite-landing-btn" href={`/login?next=${encodeURIComponent(`/invite/confirm/${token}`)}`}>
                        Войти и принять
                    </a>
                )}
                <InviteDownloadLinks />
                {error ? <p className="invite-landing-error">{error}</p> : null}
                {showOk ? (
                    <p className="invite-landing-ok">
                        Войдите в приложение или на сайт и подтвердите приглашение в разделе заявок.
                    </p>
                ) : null}
            </div>
        </div>
    );
}
